import React, { useEffect, useRef, useState } from "react"
import { ColourPalette, getAdjustingFontSizeByHeightWidth, getIsTablet, getScreenSize, getSectionHeight, isSafari, pageType } from "../globalConstants"
import { VerticalPhoneMobile, VerticalPhoneWithVideo } from "./verticalPhoneWithVideo"
import postFlopAll from "../assets/gamePlayVideo.mp4";
import gameScreenPhoto from "../assets/question_1.png"
import resultsScreen from "../assets/resultsScreen.mp4";
import resultsScreenPhoto from "../assets/answer_1.png"
import { DownloadButtonsDesktop } from "./DownloadButtonsDesktop";
import { DownloadButtonsMobile } from "./DownloadButtonsMobile";
import StatisticsAce from "../assets/Tile_Statistics.webp"
import { FlexiblePhone, FlexiblePhoneStillImage } from "./flexiblePhone";
import AppLogoTeal from "../assets/appLogoTeal.png";
import StatisticsScreen1 from "../assets/statisticsScreenSmudge.png";
import StatisticsScreen2 from "../assets/statisticsScreenSmudge2.png";
import { formatAnswer } from "./DuplicatePoker";
import StoreCreativeBackground from '../assets/storeCreativeBackgrounds6.png';
import StoreCreativeBackgroundTablet from '../assets/storeCreativeBackgrounds6Tablet.png';
import StoreCreativeBackgroundMobile from '../assets/storeCreativeBackgrounds6Mobile.png';

import StoreCreativeBackgroundNarrow from '../assets/storeCreativeBackgroundsNarrow1.png';
import { Padding } from "@mui/icons-material";
interface FeedbackEngineProps {
}

const header1 = "Analyse your game with clear, actionable stats"
const header1_1 = "Your Hand History is"
const header1_2 = "Your Edge"

const header2 =
    "Uncover your most common mistakes\n\
See if you over-bluff or over-fold\n\
Track your progress and winnings"




const header3 = "Our Best-in-Class Feedback Engine Makes Improving Simple and Fun"
export const Statistics: React.FC<FeedbackEngineProps> = () => {

    const [isVisible, setIsVisible] = useState(false);
    const [isVisible2, setIsVisible2] = useState(false);

    const divRef = useRef(null);
    const div2Ref = useRef(null);
    try {

        useEffect(() => {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            if (entry.target === divRef.current) {
                                setIsVisible(true);
                            } else if (entry.target === div2Ref.current) {
                                setIsVisible2(true);
                            }
                        } else {
                            if (entry.target === divRef.current) {
                                setIsVisible(false);
                            } else if (entry.target === div2Ref.current) {
                                setIsVisible2(false);
                            }
                        }
                    });
                },
                {
                    threshold: 0.1,
                }
            );
            if (divRef.current) {
                observer.observe(divRef.current);
            }
            if (div2Ref.current) {
                observer.observe(div2Ref.current);
            }

            return () => {
                if (divRef.current) {
                    observer.unobserve(divRef.current);
                }
                if (div2Ref.current) {
                    observer.unobserve(div2Ref.current);
                }
            };
        }, []);

        const fadeInStyle = {
            opacity: isVisible ? 1 : 0,
            transition: 'opacity 1s ease-in',
        };

        const flyInStyle = {
            transform: isVisible2 ? 'translateX(0)' : 'translateX(-200%)',
            transition: 'transform 1s ease-in-out',
        };

        const flyInStyle2 = {
            transform: isVisible2 ? 'translateX(0)' : 'translateX(-300%)',
            transition: 'transform 1s ease-in-out',
        };

        return (
            <div style={{
                height: "auto",
                width: "100%",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                position: "relative",
                overflow: "hidden",
            }}>
                <div style={{ position: "absolute", width: "100%", height: "100%" }}>
                    <img
                        src={StatisticsAce}
                        alt="Daily Tournament Tile"
                        style={{
                            width: '100%',
                            height: 'auto',
                            objectFit: 'contain',
                            position: "absolute",
                            bottom: 0,
                            right: 0
                        }}
                    />
                    <div style={{
                        position: "absolute",
                        height: "100%",
                        top: 0,
                        left: 0,
                        width: "100%",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        background: 'linear-gradient(0deg, rgba(0,234,154,0.4) 0%, rgba(0,234,154,0.4) 25%, rgb(132, 246, 206) 35%, rgb(91, 231, 182) 80%, rgb(78, 220, 170) 100%)'
                    }}></div>
                    <div style={{
                        position: "absolute",
                        height: "100%",
                        top: 0,
                        left: 0,
                        width: "100%",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        background: 'linear-gradient(180deg, rgba(256,256,256,0.4) 0%, rgba(256,256,256,0.4) 35%, rgba(242, 242, 54,0) 53%, rgba(242, 242, 242,0) 100%)'
                    }}></div>
                </div>
                {<img
                    src={StoreCreativeBackgroundMobile}
                    alt="Daily Tournament Tile"
                    style={{
                        width: "50%",
                        height: '40%',
                        objectFit: 'contain',
                        position: "absolute",
                        top: 0,
                        right: 0,
                        zIndex: 0
                    }}
                />}
                <div style={{
                    height: "auto",
                    width: "95%",
                    flexDirection: "column",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1,
                    position: "relative",
                }}>
                    {/* === HEADER — outside the box === */}
                    <div
                        ref={divRef}
                        style={{
                            ...fadeInStyle,
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            marginTop: "10%",
                            marginBottom: 25,

                        }}>
                        <h1 style={{
                            color: "#2a4432",
                            textShadow: isSafari ? "1px 1px 1px rgba(255,255,255,1)" : "2px 2px 2px rgba(255,255,255,1)",
                            width: "100%",
                            fontFamily: "Bold",
                            fontSize: getAdjustingFontSizeByHeightWidth(getScreenSize().height * 0.04, getScreenSize().width * 0.90, header1_1.length, 188),
                            textAlign: "center",
                            margin: 0,
                            lineHeight: 1.1,
                        }}>
                            {header1_1}
                        </h1>
                        <h1 style={{
                            color: "#0f1f16",
                            textShadow: isSafari ? "1px 1px 1px rgba(255,255,255,1)" : "2px 2px 2px rgba(255,255,255,1)",
                            width: "100%",
                            fontFamily: "Bold",
                            fontSize: getAdjustingFontSizeByHeightWidth(getScreenSize().height * 0.11, getScreenSize().width * 0.95, header1_2.length, 188),
                            textAlign: "center",
                            margin: 0,
                            lineHeight: 1.1,
                        }}>
                            {header1_2}
                        </h1>
                    </div>

                    {/* === CONTENT BOX — bullet points only, no header or button === */}
                    <div style={{
                        width: "100%",
                        maxWidth: getScreenSize().height / 1.45,
                        justifyContent: "center",
                        alignItems: "center",
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        padding: "5%",
                        borderRadius: "20px",
                        background: 'linear-gradient(135deg, rgb(235, 250, 245) 0%, rgb(248, 255, 252) 50%, rgb(238, 250, 246) 90%)',
                        boxShadow: `
                            0 8px 32px rgba(0, 0, 0, 0.08),
                            0 4px 16px rgba(0, 0, 0, 0.04),
                            0 2px 8px rgba(0, 0, 0, 0.02)
                        `,
                        border: "1px solid rgba(255, 255, 255, 0.6)",
                        backdropFilter: "blur(10px)",
                        marginBottom: 10,
                    }}>
                        <div style={{
                            width: "100%",
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",

                        }}>
                            {formatAnswer(header2, {
                                color: "rgb(7, 77, 53)",
                                maxWidth: "100%",
                                textShadow: "0px 0px 10px white",
                                fontFamily: "Italic",
                                fontSize: getAdjustingFontSizeByHeightWidth(getScreenSize().height * 0.2, getScreenSize().width * 0.70, header2.length, 88),
                                textAlign: "left",
                                margin: 10,
                            }, true)}
                        </div>
                    </div>

                    {/* === DOWNLOAD BUTTON — outside the box === */}
                    <div style={{ width: "100%", marginTop: "5%", marginBottom: "5%", justifyContent: "center", alignItems: "center", display: "flex" }}>
                        <DownloadButtonsMobile placement="statistics"
                            style={{ width: getScreenSize().width * 0.4 }}
                        />
                    </div>

                    {/* === PHONE IMAGES === */}
                    <div
                        ref={div2Ref}
                        style={{
                            height: getScreenSize().height * 0.53,
                            minHeight: getScreenSize().width * 0.95,
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            marginTop: 10,
                            marginBottom: 25,
                        }}>
                        <div style={{
                            ...flyInStyle2,
                            height: "100%", display: "flex", flex: 1,
                            flexDirection: "row", justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <VerticalPhoneMobile video={postFlopAll} backupPhoto={StatisticsScreen2}
                                scaleFactorInput={getScreenSize().width * 0.0045} halfMobileInput={true} />
                        </div>
                        <div style={{
                            ...flyInStyle, display: "flex", flex: 1,
                            flexDirection: "row", justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <VerticalPhoneMobile video={resultsScreen} backupPhoto={StatisticsScreen1}
                                scaleFactorInput={getScreenSize().width * 0.0045} halfMobileInput={true} />
                        </div>
                    </div>
                </div>
            </div>
        )
    } catch (err) {
        console.error('FeedbackEngine:' + err)
        return (<div></div>)
    }
}

export const StatisticsDesktop: React.FC<FeedbackEngineProps> = () => {

    const [isVisible, setIsVisible] = useState(false);
    const [isVisible2, setIsVisible2] = useState(false);

    const divRef = useRef(null);
    const div2Ref = useRef(null);
    try {

        useEffect(() => {
            const observer = new IntersectionObserver(

                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            if (entry.target === divRef.current) {
                                setIsVisible(true);
                            } else if (entry.target === div2Ref.current) {
                                setIsVisible2(true);
                            }
                        } else {
                            if (entry.target === divRef.current) {
                                setIsVisible(false);
                            } else if (entry.target === div2Ref.current) {
                                setIsVisible2(false);
                            }
                        }
                    });
                },
                {
                    threshold: 0.1, // Trigger when 50% of the div is visible
                }
            );
            if (divRef.current) {
                observer.observe(divRef.current);
            }
            if (div2Ref.current) {
                observer.observe(div2Ref.current);
            }

            return () => {
                if (divRef.current) {
                    observer.unobserve(divRef.current);
                }
                if (div2Ref.current) {
                    observer.unobserve(div2Ref.current);
                }
            };
        }, []);


        const fadeInStyle = {
            opacity: isVisible ? 1 : 0,
            transition: 'opacity 1s ease-in',
        };

        const flyInStyle = {
            transform: isVisible2 ? 'translateX(0)' : 'translateX(-200%)',
            transition: 'transform 1s ease-in-out',
        };

        const flyInStyle2 = {
            transform: isVisible2 ? 'translateX(0)' : 'translateX(-300%)',
            transition: 'transform 1s ease-in-out',
        };

        const heightReference = Math.max(0.7 * getScreenSize().height, getScreenSize().width * 0.42)
        const phoneWidth = Math.min(getScreenSize().height * 0.40, getScreenSize().width * 0.2);
        const phoneHeight = phoneWidth * 2.02535;
        const isMobileOrTablet = getIsTablet();

        return (

            <div style={{
                height: "auto",
                width: "100%",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                position: "relative",
                // Keep everything in this section inside it - an over-tall child here used to
                // spill into the section above.
                overflow: "hidden"
            }}>
                <div style={{ position: "absolute", width: "100%", height: "100%", }}>

                    <img
                        src={StatisticsAce} // Reference the imported image
                        alt="Daily Tournament Tile" // Provide an alt attribute
                        style={{
                            width: 'auto',
                            height: '100%',
                            objectFit: 'contain',
                            position: "absolute",
                            top: 0,
                            left: "6%"
                        }}
                    />
                    <div style={{
                        position: "absolute",
                        height: "100%",
                        top: 0,
                        left: 0,
                        width: "100%",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        background: 'linear-gradient(90deg,rgb(58, 246, 180) 6%, rgba(58, 246, 180,0.4) 20%,  rgba(58, 246, 180,0.4) 35%,  rgb(94, 250, 195) 45%,  rgba(94, 250, 195,1) 80%,   rgba(94, 250, 195,1) 100%)'
                    }}></div>
                    <div style={{
                        position: "absolute",
                        height: "100%",
                        top: 0,
                        left: 0,
                        width: "100%",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        background: 'linear-gradient(90deg, rgba(256,256,256,0.2) 5%, rgba(256,256,256,0.2) 35%, rgba(242, 242, 54,0) 53%, rgba(242, 242, 242,0) 100%)'
                    }}>

                    </div>
                    {/* <div style={{
                        position: "absolute", width: "50%", height: "100%", display: "flex",
                        right: 0, alignItems: "center", justifyContent: "center", opacity: 0.1,

                        backgroundImage: `url(${AppLogoTeal})`,
                        backgroundRepeat: "repeat",
                        backgroundSize: "20% auto", // or 'contain' or 'cover' depending on desired effect
                        backgroundPosition: "center"
                    }}>


                  
                    </div> */}
                </div>
                {<img
                    src={isMobileOrTablet ? StoreCreativeBackgroundTablet : StoreCreativeBackground}
                    alt="Daily Tournament Tile"
                    style={{
                        width: "100%",
                        height: '100%',
                        objectFit: 'cover',
                        position: "absolute",
                        top: 0,
                        right: 0,
                        zIndex: 0
                    }}
                />}
                <div style={{
                    height: getScreenSize().height * 0.9,
                    minHeight: getScreenSize().width * 0.42,
                    width: "95%",
                    flexDirection: "row-reverse",
                    display: "flex",
                    justifyContent: "center", alignItems: "center",
                    position: "relative",
                }}>


                    <div
                        ref={divRef}
                        style={{
                            ...fadeInStyle,
                            height: "100%", width: "50%", display: "flex",
                            flexDirection: "column", justifyContent: "center",
                            alignItems: "center"
                            , position: "relative", paddingLeft: "5%", paddingRight: "2.5%"
                        }}>
                        <div style={{ width: "100%", marginBottom: "5%", marginTop: "20%", marginLeft: "2%" }}>
                            <h1 style={{
                                width: "100%",
                                zIndex: 5,
                                fontFamily: "Bold",
                                fontSize: getAdjustingFontSizeByHeightWidth(heightReference * 0.08, getScreenSize().width * (0.35), header1_1.length, 200),
                                textAlign: "left",

                                margin: 0,
                                lineHeight: 1,
                                color: "#2a4432", textShadow: isSafari ? "1px 1px 1px rgba(255,255,255,1)" : "2px 2px 2px rgba(255,255,255,1)"

                            }}>
                                {header1_1}
                            </h1>
                            <h1 style={{
                                width: "100%",
                                zIndex: 5,
                                fontFamily: "Bold",
                                fontSize: getAdjustingFontSizeByHeightWidth(heightReference * 0.2, getScreenSize().width * (0.35), header1_2.length, 200),
                                textAlign: "left",

                                margin: 0,
                                lineHeight: 1,
                                color: "#0f1f16", textShadow: isSafari ? "1px 1px 1px rgba(255,255,255,1)" : "2px 2px 2px rgba(255,255,255,1)",
                            }}>
                                {header1_2}
                            </h1>
                        </div>
                        <div style={{
                            height: getScreenSize().height < 450 ? "33%" : "30%",
                            width: "100%",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                            paddingTop: "5%",
                            paddingLeft: "5%",
                            paddingRight: "5%",
                            paddingBottom: "5%",
                            borderRadius: "20px",
                            background: 'linear-gradient(135deg, rgb(235, 250, 245) 0%, rgb(248, 255, 252) 50%, rgb(238, 250, 246) 90%)',

                            // Professional shadow with subtle depth
                            boxShadow: `
        0 8px 32px rgba(0, 0, 0, 0.08),
        0 4px 16px rgba(0, 0, 0, 0.04),
        0 2px 8px rgba(0, 0, 0, 0.02)
    `,
                            // Subtle border for definition
                            border: "1px solid rgba(255, 255, 255, 0.6)",
                            // Better backdrop for glass-like effect
                            backdropFilter: "blur(10px)",
                            // Smooth transitions for hover effects
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                        }}>
                            {/* <h1 style={{ color: "rgb(7, 77, 53)", maxWidth: "100%", textShadow: "0px 0px 10px white", fontFamily: "Bold", fontSize: getAdjustingFontSizeByHeightWidth(getScreenSize().height * 0.2, getScreenSize().width * (0.30), header1.length, 88), justifyContent: "center", textAlign: "center" }}>{header1}</h1> */}
                            <div style={{
                                height: "100%", width: "100%", position: "relative", display: "flex", alignItems: "center",
                                justifyContent: "center", flexDirection: "column",
                            }}>
                                {formatAnswer(header2, {
                                    color: "rgb(7, 77, 53)", maxWidth: "90%", textShadow: "0px 0px 10px white", marginBottom: "1%", marginTop: "1%", width: "100%",
                                    fontFamily: "Italic", fontSize: getAdjustingFontSizeByHeightWidth(getScreenSize().height * 0.24,
                                        getScreenSize().width * (0.22), header2.length, 88), height: "100%", justifyContent: "center",
                                    textAlign: "left"
                                }, true)}</div>
                            {/* <h3 style={{ maxWidth: "80%", fontFamily: "Bold", fontSize: getAdjustingFontSizeByHeightWidth(getScreenSize().height * 0.05, getScreenSize().width * (0.90), header3.length, 88), textAlign: "center", margin: 20 }}>{header3}</h3> */}
                        </div>
                        <div style={{ width: "100%", marginTop: "8%", marginBottom: "8%", justifyContent: "center", alignItems: "center", display: "flex" }}>
                            {isMobileOrTablet ?
                                <div style={{ width: "65%", justifyContent: "center", alignItems: "center", display: "flex" }}>
                                    <DownloadButtonsMobile placement="statistics" />
                                </div>
                                :
                                <DownloadButtonsDesktop placement="statistics"
                                    width={getScreenSize().width * 0.4} height={heightReference * 0.1}
                                />
                            }
                        </div>
                    </div>
                    <div
                        ref={div2Ref}
                        style={{

                            // Sized from what actually renders (+80 for the inner column's 40px
                            // top/bottom margins) rather than from the viewport width, which made
                            // this box overflow far outside the section.
                            height: "100%", minHeight: phoneHeight + 80, display: "flex",
                            flexDirection: "row", justifyContent: "center",
                            alignItems: "center", width: "50%", position: "relative"
                        }}>
                        <div style={{
                            ...flyInStyle2,
                            height: "100%", display: "flex", flex: 1,
                            flexDirection: "row", justifyContent: "center",
                            alignItems: "center", position: "relative"
                        }}>
                            <div
                                style={{

                                    height: "100%", width: "50%", display: "flex", marginTop: 40, marginBottom: 40,
                                    flexDirection: "column", justifyContent: "center",
                                    alignItems: "center"
                                    , transform: "translateX(-3.5%)", // Fixed transform syntax
                                }}>
                                <div style={{
                                    height: phoneHeight,
                                    width: phoneWidth,
                                }}>
                                    <FlexiblePhoneStillImage marginHorizontal={"3%"}
                                        marginTop={"1%"} videoBorderRadius={70 * (getScreenSize().width * 0.2 / 400)} image={StatisticsScreen2} ></FlexiblePhoneStillImage>
                                </div>
                            </div>
                        </div>
                        <div style={{

                            ...flyInStyle, display: "flex", flex: 1,
                            flexDirection: "row", justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <div
                                style={{

                                    height: "100%", width: "50%", display: "flex", marginTop: 40, marginBottom: 40,
                                    flexDirection: "column", justifyContent: "center",
                                    alignItems: "center"
                                    , transform: "translateX(-3.5%)", // Fixed transform syntax
                                }}>
                                <div style={{
                                    height: phoneHeight,
                                    width: phoneWidth,
                                }}>
                                    <FlexiblePhoneStillImage image={StatisticsScreen1} marginHorizontal={"3%"}
                                        marginTop={"1%"} videoBorderRadius={70 * (getScreenSize().width * 0.2 / 400)} ></FlexiblePhoneStillImage>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    } catch (err) {
        console.error('FeedbackEngine:' + err)
        return (<div></div>)
    }
}